<template>
  <div
    id="emp_record"
    class="
      shadow-xl
      rounded-md
      lg:border-2 lg:border-blue-600 lg:p-5 lg:ml-6
      md:ml-10
      relative
    "
  >
    <div
      id="formtitle"
      class="
        border-2
        w-full
        flex
        justify-center
        items-center
        bg-blue-600
        text-blue-200
      "
    >
      <div class="text-sm breadcrumbs">
        <ul>
          <li>
            <a>Application</a>
          </li>
          <li>
            <a>Employement Record</a>
          </li>
        </ul>
      </div>
    </div>
    <vee-form
      :validation-schema="schema"
      class="
        lg:h-auto
        w-full
        flex flex-col
        items-center
        justify-center
        px-8
        py-4
        mx-5
        lg:grid lg:grid-flow-row lg:grid-cols-3 lg:gap-2
      "
    >
      <div class="form-control w-full">
        <label for="from" class="label">
          <span class="label-text">From</span></label
        >
        <vee-field
          name="from"
          v-model="from"
          type="date"
          id="from"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="from" />
      </div>
      <div class="form-control w-full">
        <label for="to" class="label">
          <span class="label-text">To</span></label
        >
        <vee-field
          name="to"
          v-model="to"
          type="date"
          id="to"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="to" />
      </div>
      <div class="form-control w-full">
        <label for="Organization" class="label">
          <span class="label-text">Organization</span></label
        >
        <vee-field
          name="Organization"
          v-model="Organization"
          type="text"
          id="Organization"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Organization" />
      </div>
      <div class="form-control w-full">
        <label for="designation" class="label">
          <span class="label-text">Designation</span></label
        >
        <vee-field
          name="designation"
          v-model="Designation"
          type="text"
          id="designation"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="designation" />
      </div>
      <div class="form-control w-full">
        <label for="NatureofDuties" class="label">
          <span class="label-text">Nature of Duties</span></label
        >
        <vee-field
          name="NatureofDuties"
          v-model="Nature_of_Duties"
          type="text"
          id="NatureofDuties"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="NatureofDuties" />
      </div>
      <div class="form-control w-full">
        <label for="Resonforleaving" class="label">
          <span class="label-text">Reason for leaving</span></label
        >
        <vee-field
          name="Reasonforleaving"
          v-model="Reasons"
          type="text"
          id="Resonforleaving"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Reasonforleaving" />
      </div>
      <div class="w-full text-center col-span-3">
        <p>
          <span class="font-bold text-2xl text-red-500">*</span> If you are a
          <strong class="text-blue-500">Fresher</strong> just skip this section
          and move on to <i class="text-blue-500 font-bold">Next</i> section.
        </p>
      </div>
      <div class="form-control w-full lg:w-min mt-5">
        <input @click="addEmp" type="button" value="Add" class="btn btn-info" />
      </div>
    </vee-form>

    <div class="grid px-5 py-4">
      <div class="overflow-y-auto">
        <table class="table w-full">
          <thead>
            <tr>
              <th></th>
              <th>Action</th>
              <th>From</th>
              <th>To</th>
              <th>Organization</th>
              <th>Designation</th>
              <th>Nature-of-Duties</th>
              <th>Reason for leaving</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, i) in employeerecord" :key="i">
              <th scope="row">{{ ++i }}</th>
              <div
                class="tooltip tooltip-right"
                data-tip="After editing your details click add and then save."
              >
                <td>
                  <span class="cursor-pointer" @click="editRow(--i)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </span>
                </td>
              </div>
              <td>{{ entry.From }}</td>
              <td>{{ entry.To }}</td>
              <td>{{ entry.Organization }}</td>
              <td>{{ entry.Designation }}</td>
              <td>{{ entry.Nature_of_Duties }}</td>
              <td>{{ entry.Reasons }}</td>
            </tr>
          </tbody>
        </table>
        <div
          id="button"
          class="
            mt-6
            mb-5
            border-t-2
            p-2
            flex
            items-center
            justify-center
            tooltip
          "
          data-tip="Before clicking Save, Click Add to Insert Your Details to the Table Above. And then click Save"
        >
          <button
            @click="EmpData"
            class="btn btn-info mb-2 hover:bg-blue-500 lg:w-96"
          >
            <span v-if="status"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                /></svg
            ></span>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
    <div>
      <div v-if="response" class="alert alert-info absolute bottom-5 right-3">
        <div class="flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            ></path>
          </svg>
          <label
            >Your data has been saved click next to fill more details</label
          >
        </div>
      </div>
      <div v-if="error" class="alert alert-error absolute bottom-5 right-3">
        <div class="flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            ></path>
          </svg>
          <label
            >Your data is not saved please try again later or call sitra
            customer serive
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Employerrecord",
  data() {
    return {
      status: false,
      response: false,
      error: false,
      schema: {
        from: "required",
        to: "required",
        Organization: "required|alpha_spaces",
        designation: "required|alpha_spaces",
        NatureofDuties: "required|alpha_spaces",
        Reasonforleaving: "required|alpha_spaces",
      },
      from: "",
      to: "",
      Organization: "",
      Designation: "",
      Nature_of_Duties: "",
      Reasons: "",
    };
  },
  mounted() {
    this.getEmpData();
  },
  beforeUnmount() {
    this.deleteEmpInfo();
  },
  computed: {
    employeerecord() {
      return this.$store.state.Candidate.application.employeerecord;
    },
  },
  methods: {
    addEmp() {
      if (
        this.from !== "" &&
        this.to !== "" &&
        this.Organization !== "" &&
        this.Designation !== "" &&
        this.Nature_of_Duties !== "" &&
        this.Reasons !== ""
      )
        this.$store.dispatch("Candidate/addEmp", {
          Reg_id: sessionStorage.getItem("id"),
          From: this.from,
          To: this.to,
          Organization: this.Organization,
          Designation: this.Designation,
          Nature_of_Duties: this.Nature_of_Duties,
          Reasons: this.Reasons,
        });
      this.clearForm();
    },
    deleteEmpInfo() {
      this.$store.commit("Candidate/deleteEmp");
    },
    clearForm() {
      this.from = "";
      this.to = "";
      this.Organization = "";
      this.Designation = "";
      this.Nature_of_Duties = "";
      this.Reasons = "";
    },
    editRow(i) {
      this.from = this.employeerecord[i].From;
      this.to = this.employeerecord[i].To;
      this.Organization = this.employeerecord[i].Organization;
      this.Designation = this.employeerecord[i].Designation;
      this.Nature_of_Duties = this.employeerecord[i].Nature_of_Duties;
      this.Reasons = this.employeerecord[i].Reasons;

      this.$store.dispatch("Candidate/removeEmp", i);
    },
    EmpData() {
      if (this.employeerecord.length == 0) {
        alert(
          "After filling the form click add button to insert it to the table and then click save."
        );
      } else {
        const jsonEmp = JSON.stringify(this.employeerecord);
        // console.log(jsonEmp);
        axios
          .post(
            `http://sitraonline.org.in/employementhubapi/index.php/api/InsertExperience`,
            jsonEmp
          )
          .then((res) => {
            // console.log(res);
            if (res.status == 200) {
              this.status = true;
            }
          })
          .catch((err) => alert(err));
      }
    },
    async getEmpData() {
      const data = await fetch(
        ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/SelectExperience`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Reg_id: sessionStorage.getItem("id") }),
        }
      );
      try {
        let res = await data.json();
        for (let i = 0; i < res.length; i++) {
          this.employeerecord.push(res[i]);
        }
      } catch (err) {
        alert(err);
      }
    },
  },
};
</script>
